/**
 * Class description
 *
 * Created: 2019-08-02
 * @author jonas
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {SpacierArcadeSoundConfig} from "../SpacierArcadeSoundConfig";
import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";


export class SARespinTransitionContorller extends GameModeTransitionController {

    constructor(fromMode:string, toMode:string) {
        super(fromMode, toMode);
    }

    /**
     * Set up mode views and layout while screen is covered by intro/outro screen.
     */
    protected prepareToEnterMode():void {
        if(this._toMode == SpacierArcadeGameMode.RESPIN) {
            SlotGame.sound.playAmbience(SpacierArcadeSoundConfig.instance.RESPIN_AMBIANCE);
        }

        if(this._toMode == GameMode.NORMAL) {
            // SlotGame.sound.playAmbience(SpacierArcadeSoundConfig.instance.MAIN_GAME_AMBIANCE);
        }
        super.prepareToEnterMode();
    }

}